import { fetchTaskCategories } from './effects';
import { $taskCategories } from './states';

$taskCategories.on(fetchTaskCategories.doneData, (_, data) => data);
